// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3co_i","col":"styles_col__Syi-3"};